import PageQuery from './components/PageQuery';

export default PageQuery;

export {
  default as PageContext,
  usePageQuery,
  defaultContextValue,
} from './contexts/PageQueryContext';

export type { Peer } from './contexts/PageQueryContext';
